import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	const [roledata, setRoleData] = useState([]);
	const [rolenamedata, setRoleNameData] = useState([]);
	// const [item1, setItem]= useState([]);
	const [dataval, setDataVal] = useState([]);
	const [isVisible, setIsVisible] = useState(false);

	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);


	const handleCheckboxChange = (e) => {
		// e.preventDefault();
		const value = e.target.value;


		if (e.target.checked) {
			setSelectedItems([...selectedItems, value]);
		} else {
			setSelectedItems(selectedItems.filter(item => item !== value));
		}
	};


	function checkboxHandler(e) {
		// e.preventDefault();
		let isSelected = e.target.checked;
		let value = parseInt(e.target.value);




		if (isSelected) {
			setRoleData([...roledata, value]);
		} else {
			setRoleData((prevData) => {
				return prevData.filter((id) => {
					return id != value
				});
			})
		}
	}











	const handleEditSubmit = (e) => {

		e.preventDefault();
		//console.log('selected options: '+ roledata.join(", "));
		// e.preventDefault();
		//console.log(param);




		axios.post(API_BASE_URL + '/updaterole', { menu_id: roledata.join(","), role_id: param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {

			// console.log(response.data);

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				setTimeout(() => {
					return history.push("/hr-roleaccess?id="+param);
				}, 3000);

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {

			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});







	};



	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchmenu_condition/'+ param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			// .then(res => console.log(res.data))
			.then(res => setData(res.data))
			.catch(err => console.log(err));
	}, [])


	useEffect(() => {
		axios.get(API_BASE_URL + '/showroleaccess/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			//  .then(res1 =>console.log(res1.data))
			.then(res1 => setRoleData(res1.data))
			.catch(err => console.log(err));
	}, [])

    useEffect(() => {
		axios.get(API_BASE_URL + '/showrolenameaccess/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			  //.then(res1 =>console.log(res1.data))
			 .then(res1 => setRoleNameData(res1.data))
			.catch(err => console.log(err));
	}, [])


	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title">Add Role Access </h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="tag tag-danger">{rolenamedata}</span>
										</div>
										<div className="card-body">

											<form onSubmit={handleEditSubmit}>
												{data.map((item, index) => {
													return (
														<div key={index}>
															<div>


																{/* <div>{item1.includes(item.id) ? "checked" : "unchecked"}</div> */}

																<div className="col-md-6 col-sm-6">
																	<div className="form-group">
																		{/* <input type="text" className="form-control" name="sub_menu_name" 
					placeholder="Sub Menu Name" value={item.sub_menu_name}
					onChange={(event) => handleChange(event, index)}/> 
					
					checked={item1.includes(item.id) ? "checked" : ""}*/
																		}
																		<label className="custom-control custom-checkbox custom-control-inline">
																			<input type="checkbox" className="custom-control-input" defaultValue={item.id} checked={roledata.includes(item.id)} onChange={checkboxHandler} />
																			<span className="custom-control-label">{item.menu_name} </span>
																		</label>
																	</div>
																</div>



															</div>


														</div>



													)
												})}

												{/* <div className="body"> {JSON.stringify(users)} </div> */}

												<div class="row">

													{/* <div className="body"> {JSON.stringify(item)} </div>  */}

													<div className="col-md-2 col-sm-6">
														<div className="form-group">

															<button type="submit" className="btn btn-primary">
																Add Role Access
															</button>

															{/* <h2>Result will print here : {roledata.toString()}</h2> */}

														</div>
													</div>


												</div>
											</form>




										</div>
									</div>
								</div>

							</div>
						</div>
					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);